var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('a',{on:{"click":function($event){return _vm.openModal()}}},[_vm._v("FAQ")])])}
var staticRenderFns = []

export { render, staticRenderFns }